<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="6"
        md="6"
        sm="6"
      >
        <span style="padding-left: 25px; padding: 10px; text-align: left; font-size:18px;">{{ plc_nameLI }}</span>
        <b-card
          no-body
          class="d-flex justify-content-between align-items-center"
        >
          <b-row>
            <b-img
              style="padding-bottom: 5px; padding-top: 5px; height: 200px; text-align: center;"
              :src="Reverse_LEFT_IN"
            />
          </b-row>
        </b-card>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="6"
      >
        <span style="padding-left: 25px; padding: 10px; text-align: left; font-size:18px;">{{ plc_nameRI }}</span>
        <b-card
          no-body
          class="d-flex justify-content-between align-items-center"
        >
          <b-row>
            <b-img
              style="padding-bottom: 5px; padding-top: 5px; height: 200px; text-align: center;"
              :src="Reverse_RIGHT_IN"
            />
          </b-row>
        </b-card>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="6"
      >
        <span style="padding-left: 25px; padding: 10px; text-align: left; font-size:18px;">{{ plc_nameLO }}</span>
        <b-card
          no-body
          class="d-flex justify-content-between align-items-center"
        >
          <b-row>
            <b-img
              style="padding-bottom: 5px; padding-top: 5px; height: 200px; text-align: center;"
              :src="Reverse_LEFT_OUT"
            />
          </b-row>
        </b-card>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="6"
      >
        <span style="padding-left: 25px; padding: 10px; text-align: left; font-size:18px;">{{ plc_nameRO }}</span>
        <b-card
          no-body
          class="d-flex justify-content-between align-items-center"
        >
          <b-row>
            <b-img
              style="padding-bottom: 5px; padding-top: 5px; height: 200px; text-align: center;"
              :src="Reverse_RIGHT_OUT"
            />
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      Reverse_LEFT_IN: '',
      Reverse_RIGHT_IN: '',
      Reverse_LEFT_OUT: '',
      Reverse_RIGHT_OUT: '',
      plc_nameLI: '',
      plc_nameRI: '',
      plc_nameLO: '',
      plc_nameRO: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getReverse()
    setInterval(() => {
      this.getReverse()
    }, 600000)
  },
  methods: {
    getReverse() {
      axios
        .post('/statusReverseDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.plc_nameLI = response.data[0].plc_name
          this.plc_nameRI = response.data[1].plc_name
          this.plc_nameLO = response.data[2].plc_name
          this.plc_nameRO = response.data[3].plc_name
          if (response.data[0].isset === 0) {
            this.Reverse_LEFT_IN = require('@/assets/images/icons/reverse-off1.png')
          } else {
            this.Reverse_LEFT_IN = require('@/assets/images/icons/reverse-on1.png')
          }
          if (response.data[1].isset === 0) {
            this.Reverse_RIGHT_IN = require('@/assets/images/icons/reverse-off1.png')
          } else {
            this.Reverse_RIGHT_IN = require('@/assets/images/icons/reverse-on1.png')
          }
          if (response.data[2].isset === 0) {
            this.Reverse_LEFT_OUT = require('@/assets/images/icons/reverse-off1.png')
          } else {
            this.Reverse_LEFT_OUT = require('@/assets/images/icons/reverse-on1.png')
          }
          if (response.data[3].isset === 0) {
            this.Reverse_RIGHT_OUT = require('@/assets/images/icons/reverse-off1.png')
          } else {
            this.Reverse_RIGHT_OUT = require('@/assets/images/icons/reverse-on1.png')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style>

  </style>
